import React, { useState } from 'react'

import {
  COLORS,
  COLOR_MODE_KEY,
  INITIAL_COLOR_MODE_CSS_PROP
} from '../constants'

export const ThemeContext = React.createContext()

export const ThemeProvider = ({ children }) => {
  const [colorMode, rawSetColorMode] = React.useState(undefined);
  const [settings, setSettings] = useState([])

  React.useEffect(() => {
    const root = window.document.documentElement;

    // Because colors matter so much for the initial page view, we're
    // doing a lot of the work in gatsby-ssr. That way it can happen before
    // the React component tree mounts.

    const initialColorValue = root.style.getPropertyValue(
      INITIAL_COLOR_MODE_CSS_PROP
    )

    rawSetColorMode(initialColorValue)
  }, [])

  const contextValue = React.useMemo(() => {
    function setColorMode (newValue) {
      const root = window.document.documentElement

      let storage
      // if (typeof window !== 'undefined') {
        if (localStorage.getItem("sv-app") !== null) {
          storage = localStorage.getItem("11er-team-app-settings");
          setSettings(JSON.parse(storage))
        } else {
          
        }
      // }

      let settingsCopy = [...settings]
      // create a copy of our settings state, avoid overwritting existing state
      if (Array.isArray(settings) && settings.length) {
        const settingsCopy = []
      }
      else {
        if (storage) {
          settingsCopy = JSON.parse(storage)
        } else {
          settingsCopy = [...settings]
        }
      }

      let item

      let copy

      if(storage) {
        copy = JSON.parse(storage)
      } else copy = null


      if (copy === null) {
        item = {
          // consent: 'yes',
          colorMode: newValue,
          videos: 'no'
        //   advert: 'yes',
        //   pwa: 'no'
        }


        // settingsCopy.push(item)
        settingsCopy = [item]
        // cartCopy = [...cart, item]

        // update app state
        setSettings(settingsCopy)

        // make cart a string and store in local space
        let stringifiedSettings = JSON.stringify(settingsCopy);
        localStorage.setItem("11er-team-app-settings", stringifiedSettings)
      }

      if (copy) {
        item = {
          // consent: 'yes',
          colorMode: newValue,
          videos: copy && copy.length ? copy.map(item => item.videos).toString() : 'no',
          // advert: copy && copy.length ? copy.map(item => item.advert).toString() : 'yes',
          // pwa: copy && copy.length ? copy.map(item => item.pwa).toString() : 'no',
        }


        // settingsCopy.push(item)
        settingsCopy = [item]
        // cartCopy = [...cart, item]

        // update app state
        setSettings(settingsCopy)

        // make cart a string and store in local space
        let stringifiedSettings = JSON.stringify(settingsCopy);
        localStorage.setItem("11er-team-app-settings", stringifiedSettings)
      }


      Object.entries(COLORS).forEach(([name, colorByTheme]) => {
        const cssVarName = `--color-${name}`;

        root.style.setProperty(cssVarName, colorByTheme[newValue]);
      });

      rawSetColorMode(newValue);
    }

    return {
      colorMode,
      setColorMode,
    }
  }, [colorMode, rawSetColorMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}
